var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0.582031 7.00016C0.582031 3.4561 3.45463 0.583496 6.9987 0.583496C10.5428 0.583496 13.4154 3.4561 13.4154 7.00016C13.4154 10.5436 10.5428 13.4168 6.9987 13.4168C3.4546 13.4168 0.582031 10.5436 0.582031 7.00016Z",
    fill: "#494949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50378 4.77318C7.50378 4.49341 7.27696 4.2666 6.9972 4.2666C6.71743 4.2666 6.49062 4.49341 6.49062 4.77318V6.49425H4.7683C4.48852 6.49425 4.26172 6.721 4.26172 7.00083C4.26172 7.2806 4.48852 7.50741 4.7683 7.50741H6.49062V9.22627C6.49062 9.50603 6.71743 9.73285 6.9972 9.73285C7.27696 9.73285 7.50378 9.50603 7.50378 9.22627V7.50741H9.22594C9.50578 7.50741 9.73252 7.2806 9.73252 7.00083C9.73252 6.721 9.50578 6.49425 9.22594 6.49425H7.50378V4.77318Z",
    fill: "#494949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterPlus);
export default __webpack_public_path__ + "static/media/filterPlus.486e7de25d01d2cf9845d3f604c67f57.svg";
export { ForwardRef as ReactComponent };